module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Phone-d3c7200b4891f6198c40e118a1bac172.svg";